exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiple-upload[data-v-1fc2d48c] .el-upload--picture-card {\r\n    width: auto;\r\n    height: 0px;\r\n    line-height: 12px;\r\n    border: 0px dashed #c0ccda;\n}\r\n", ""]);

// exports
